import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components';
import { projects } from '../../data/constants';
import Projectcard from '../Cards/Projectcard';

const shimmer = keyframes`
  0% { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

const Container = styled.div`
  background: linear-gradient(
    180deg,
    ${({ theme }) => theme.primary + '08'} 0%,
    transparent 50%,
    ${({ theme }) => theme.accent + '08'} 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
  padding: 60px 20px;
`;

const Wrapper = styled.div`
  max-width: 1350px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 12px;
  padding: 20px 0px 80px 0;
`;

const Title = styled.h2`
  font-size: 48px;
  font-weight: 700;
  text-align: center;
  margin-top: 20px;
  background: ${({ theme }) => theme.gradient_text};
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${shimmer} 3s linear infinite;

  @media (max-width: 768px) {
    margin-top: 12px;
    font-size: 36px;
  }
`;

const Desc = styled.p`
  font-size: 18px;
  max-width: 600px;
  text-align: center;
  color: ${({ theme }) => theme.text_secondary};
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const ToggleGroup = styled.div`
  display: flex;
  border: 2px solid ${({ theme }) => theme.primary};
  color: ${({ theme }) => theme.primary};
  font-size: 16px;
  border-radius: 14px;
  font-weight: 600;
  margin: 22px 0;
  overflow: hidden;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

const ToggleButton = styled.button`
  padding: 10px 24px;
  cursor: pointer;
  border: none;
  background: ${({ active, theme }) => active ? theme.gradient_primary : 'transparent'};
  color: ${({ active, theme }) => active ? theme.bg : theme.primary};
  font-weight: 600;
  font-size: inherit;
  transition: all 0.3s ease;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.gradient_primary};
    transition: left 0.3s ease;
    z-index: -1;
  }
  
  &:hover {
    background: ${({ active, theme }) => active ? theme.gradient_primary : theme.primary + '20'};
  }
  
  @media (max-width: 768px) {
    padding: 8px 12px;
  }
`;

const Divider = styled.div`
  width: 2px;
  background: ${({ theme }) => theme.primary};
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex-wrap: wrap;
  gap: 32px;
  margin-top: 20px;
`;

const Projects = () => {

  return (
    <Container id='projects'>
      <Wrapper>
        <Title>Projects</Title>
        <Desc>
          Featured projects I've built. Each one taught me something new.
        </Desc>

        <CardContainer>
          {projects.map((project, index) => (
            <Projectcard key={index} project={project} />
          ))}
        </CardContainer>
      </Wrapper>
    </Container>
  );
};

export default Projects;